// import app from '$$app';
import _ from '../../libs/lodash';

const userProjectConfigs = new webix.DataCollection();

userProjectConfigs.userPropertyList = {
  skin: 'mainProperty',
  skip_off_time: 'property',
  right_side_text: 'property',
  highlight_critical_path: 'property',
  resource_loading_type: 'property',
  durationData: {
    mode: 'property',
    view: 'property',
    durationUnit: 'property',
  },
  view_mode: 'property',
  initGridColumns: 'object',
  current_day_marker: 'property',
  show_advanced_buttons: 'property',
  show_resource_avatar: 'property',
  highlight_overdue: 'property',
  cross_out_tasks: 'property',
  discoloration_tasks: 'property',
};

// here
userProjectConfigs.initProjects = function (projectsArray) {
  const projectsConfigArray = [];

  _.each(projectsArray, prConfig => {
    if (prConfig.userConfig) {
      projectsConfigArray.push({
        id: prConfig.gantt_id,
        gantt_id: prConfig.gantt_id,
        userConfig: prConfig.userConfig,
        userSkin: prConfig.userSkin,
        show_resource_avatar: prConfig.show_resource_avatar,
      });
    }
  });

  userProjectConfigs.parse(projectsConfigArray);
};

// here
userProjectConfigs.getUserConfigByGanttId = function (ganttId) {
  const config = userProjectConfigs.getItem(ganttId);

  if (config && config.userConfig) {
    const userSkin = userProjectConfigs.getUserSkinByGanttId(ganttId);

    if (userSkin) {
      config.userConfig.userSkin = userSkin;
    }

    return config.userConfig;
  }

  return null;
};

// here
userProjectConfigs.getUserSkinByGanttId = function (ganttId) {
  const config = userProjectConfigs.getItem(ganttId);

  if (config && config.userSkin) {
    return config.userSkin;
  }

  return null;
};

userProjectConfigs.mergeProjectConfigToUserConfig = function (projectConfig, userConfig) {
  const userConfigKeys = Object.keys(userConfig || {});
  const userConfigKeysLength = userConfigKeys.length;
  let userConfigKeysIndex = 0;

  for (userConfigKeysIndex = 0; userConfigKeysIndex < userConfigKeysLength; userConfigKeysIndex++) {
    const userIndex = userConfigKeys[userConfigKeysIndex];

    if (typeof projectConfig[userIndex] === 'object' && typeof userConfig[userIndex] === 'object') {
      projectConfig[userIndex] = userProjectConfigs.mergeProjectConfigToUserConfig(projectConfig[userIndex], userConfig[userIndex], true);
    } else {
      projectConfig[userIndex] = userConfig[userIndex];
    }
  }

  return projectConfig;
};

userProjectConfigs.getUserConfigByGanttIdAndMergeToProjectConfig = function (ganttId, projectConfig) {
  const userConfig = userProjectConfigs.getUserConfigByGanttId(ganttId);

  if (!userConfig) {
    return projectConfig;
  }

  const userSkin = userProjectConfigs.getUserSkinByGanttId(ganttId);

  if (userSkin) {
    projectConfig.userSkin = userSkin;
  }

  return userProjectConfigs.mergeProjectConfigToUserConfig(projectConfig, userConfig);
};



export default userProjectConfigs;
